const STORAGE_KEY = 'embertime.recentProjects'
const MAX_RECENT = 5

export function getRecentProjects(): string[] {
  if (typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const arr = JSON.parse(raw)
    return Array.isArray(arr) ? arr.filter((id): id is string => typeof id === 'string') : []
  } catch {
    return []
  }
}

export function pushRecentProject(id: string) {
  if (typeof window === 'undefined' || !id) return
  const current = getRecentProjects().filter((x) => x !== id)
  const next = [id, ...current].slice(0, MAX_RECENT)
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // ignore quota errors
  }
}
